import { ITask } from "dto/ITask";

export enum HubCallbacksNames {
  CalendarSynchronized = "calendarSynchronized",
  UserIdentified = "userIdentified",
  Online = "online",
  Offline = "offline",
  PIImportProgress = "importProgress",
  NewDossierItem = "newDossier",
  NewEvent = "newEvent",
  NewMessage = "newMessages",
  SpaceUsageChanged = "spaceUsageChanged",
  PrivilegesChanged = "privilegesChanged",
  /** Ktoś przyjął zaproszenie do konwersacji i czeka na przeszyfrowanie kluczy. */
  ContactFormKeysToShare = "contactFormKeysToShare",
  /** W firmie jest członek czekający na klucz firmy (model kluczy firmowych, F2). */
  WorkspaceKeysToIssue = "workspaceKeysToIssue",
  /** EBI: przesyłki czekają na przeszyfrowanie dla petentów (KeysManager przejmuje zadanie). */
  EbiKeysToShare = "ebiKeysToShare",
}

export interface ICalendarSynchronized {
  new: ITask[];
  modified: ITask[];
  syncDate: string;
}

export interface IUserIdentified {
  success: boolean;
  isPESELInUse: boolean;
  message: string;
}

export interface IImportProgress {
  isConfigured: boolean;

  current: number;
  total: number;

  message: string;
  portalName: string;
  status: ImportStatus;
  step: ImportStep;
}

export enum ImportStatus {
  NotRunning = 0,
  Starting = 1,
  Running = 2,
  Finished = 3,

  Error = 9,
}

export enum ImportStep {
  Documents = 0,
  Deliveries = 1,
  Lawsuits = 2,
  Applications = 3,
  BatchReceive = 4,
  Deliverances = 5,
  Email = 6,
}
